import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconExpandNav(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M4 17a1 1 0 1 0 2 0V7a1 1 0 1 0-2 0v10ZM19.707 12.707a1 1 0 0 0 0-1.414l-3-3a1 1 0 1 0-1.414 1.414L16.586 11H9a1 1 0 1 0 0 2h7.586l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3Z"
      />
    </BaseIcon>
  );
}
